import "./SingleContentBlockData.scss";

import React from "react";

import {
  FeatureToggle,
  SingleContentBlock
} from "../../models/app-data-model";
import CompareGroupContent from "../compare-group/CompareGroup";
import EmbeddableContent from "../embeddable-content/EmbeddableContent";
import Media from "../media/Media";
import PhLink from "../ph-link/ph-link";
import UserPathGroup from "../user-path-group/UserPathGroup";
import RichTextBlock from "../rich-text-block/RichTextBlock";

export type SingleContentBlockDataProps = {
  singleContentBlock?: SingleContentBlock;
  featureToggles: FeatureToggle[];
};

const SingleContentBlockData: React.FC<SingleContentBlockDataProps> = ({ singleContentBlock: singleContentBlock, featureToggles }) => {
  const renderContent = (column: any, index: number) => {
    if (column.heading) {
      return <column.heading.heading_type key={index}>{column.heading.headline}</column.heading.heading_type>;
    } else if (column.media) {
      return <Media mediaData={column.media} key={index} />;
    } else if (column.rich_text?.copy) {
      return <RichTextBlock content={column.rich_text.copy} key={index} />
    } else if (column.embeddable_content) {
      return <EmbeddableContent embedContentData={column.embeddable_content} key={index} featureToggles={featureToggles} />;
    } else if (column.button) {
      return <PhLink key={index} className={column.button.button_type} label={column.button.label} reference={column.button.reference} sx={{ display: "", alignItems: ""}} />
    } else if (column.user_path_group) {
      return <UserPathGroup user_path_group={column.user_path_group} key={index} />;
    } else if (column.compare_group) {
      return <CompareGroupContent content={column.compare_group.content} key={index} />;
    } else {
      return null;
    }
  };

  const container_style = singleContentBlock?.container_style;

  return (
    <div className={'single-content-block ' + container_style}>
      {singleContentBlock?.single_column?.map((column, index) => renderContent(column, index))}
    </div>
  );
};

export default SingleContentBlockData;
